module.exports = __webpack_public_path__ + "img/5.418d1d0f.jpg";